<template>
  <v-row dense style="line-height: 36px;" class="align-center">
    <v-col class="d-lg-inline-flex align-center" v-if="items && items.length > 0">
      <v-radio-group v-model="selectedItem"
                     :column="$vuetify.breakpoint.mdAndDown"
                     class="mt-0 pt-0"
                     hide-details
                     mandatory>
        <v-radio v-for="(item, index) in items" :key="index" class="mr-0 mr-sm-5"
                 :value="item.id">
          <template #label>
            {{ item.name }}
          </template>
        </v-radio>
      </v-radio-group>
    </v-col>
    <v-col v-else>Keine Daten verfügbar</v-col>

    <v-col cols="auto">
      <v-btn icon style="float: right;" @click="$emit('delete')">
        <v-icon>icon-delete</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: 'FinScreenerRadioButtonsSelector',
  components: {},
  props: {
    label: {
      type: String
    },
    value: {
      type: Object
    },
    items: {
      type: Array
    },
  },
  computed: {
    selectedItem: {
      get() {
        return this.value?.id || this.items[0].id
      },
      set(newVal) {
        const selected = this.items.find(item => item.id === newVal)
        // Returns the changed selection
        this.$emit('input', selected)
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
